<template>
    <div class="w-full font-sans">
        <transition name="fade">
            <div
                v-if="!itemsCurrent.length"
                class="flex flex-col items-center justify-center py-12 px-4 border-2 border-dashed border-theme-border rounded-xl text-center"
            >
                <span class="text-4xl mb-3">⚗️</span>
                <p class="text-sm font-semibold text-primary mb-1">
                    Sin filtros configurados
                </p>
                <p v-if="enabled" class="text-sm text-primary">
                    Agrega un filtro para comenzar
                </p>
            </div>
        </transition>

        <transition name="slide-up">
            <div
                v-if="itemsCurrent.length"
                class="rounded-xl border border-theme-border overflow-hidden shadow-sm"
            >
                <table class="w-full text-md !border-0" :class="tableDark">
                    <thead class="bg-theme-card">
                        <tr>
                            <th
                                class="w-12 px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider text-primary border-b border-theme-border"
                            >
                                #
                            </th>
                            <th
                                class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-primary border-b border-theme-border"
                            >
                                Nombre
                            </th>
                            <th
                                class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-primary border-b border-theme-border"
                            >
                                Llave
                            </th>
                            <th
                                class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-primary border-b border-theme-border"
                            >
                                Tipo
                            </th>
                            <th
                                v-if="enabled"
                                class="w-40 px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider text-primary border-b border-theme-border"
                            >
                                Acciones
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(item, index) in itemsCurrent"
                            :key="index"
                            class="border-b border-theme-border last:border-0 transition-colors duration-150"
                        >
                            <td class="px-4 py-3 text-center">
                                <span
                                    class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-theme-hover border border-theme-border text-xs font-semibold text-primary"
                                >
                                    {{ index + 1 }}
                                </span>
                            </td>

                            <td class="px-4 py-3">
                                <span class="font-medium text-theme-base">
                                    {{ item.name }}
                                </span>
                            </td>

                            <td class="px-4 py-3">
                                <span
                                    class="inline-block px-2 py-0.5 rounded bg-theme-hover border border-theme-border text-theme-success text-xs font-mono font-medium"
                                >
                                    {{ item.key }}
                                </span>
                            </td>

                            <td class="px-4 py-3">
                                <span
                                    class="inline-block px-2 py-0.5 rounded bg-theme-hover border border-theme-border text-theme-primary text-xs font-mono font-medium"
                                >
                                    {{ item.type }}
                                </span>
                            </td>

                            <td v-if="enabled" class="px-4 py-3">
                                <div
                                    class="flex items-center justify-center gap-1"
                                >
                                    <button
                                        class="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-theme-card text-primary hover:bg-theme-hover transition-all duration-150 disabled:opacity-30 disabled:cursor-not-allowed"
                                        :disabled="index === 0"
                                        title="Subir"
                                        @click="moveOrder(index, index - 1)"
                                    >
                                        ⬆️
                                    </button>

                                    <button
                                        class="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-theme-card text-primary hover:bg-theme-hover transition-all duration-150 disabled:opacity-30 disabled:cursor-not-allowed"
                                        :disabled="
                                            index >= itemsCurrent.length - 1
                                        "
                                        title="Bajar"
                                        @click="moveOrder(index, index + 1)"
                                    >
                                        ⬇️
                                    </button>

                                    <button
                                        class="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-theme-card text-primary hover:bg-theme-hover hover:text-theme-primary hover:border-theme-primary transition-all duration-150"
                                        title="Editar"
                                        @click="editItem(index)"
                                    >
                                        🖊️
                                    </button>

                                    <button
                                        class="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-theme-card text-primary hover:bg-theme-hover hover:text-theme-danger hover:border-theme-danger transition-all duration-150"
                                        title="Eliminar"
                                        @click="deleteItem(index)"
                                    >
                                        ✕
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </transition>

        <div v-if="enabled" class="flex items-center justify-between mt-4">
            <div class="flex-1">
                <slot name="action"></slot>
            </div>
            <custom-tooltip border>
                <button
                    class="inline-flex items-center gap-2 px-4 py-2 rounded-lg border-2 bg-brand-blue text-sm font-semibold text-white hover:shadow-lg transition-all duration-200"
                    @click="openNewFilter"
                >
                    <span class="text-base leading-none">+</span>
                    <span>Agregar filtro</span>
                </button>
                <template #tooltip>Agregar nuevo filtro</template>
            </custom-tooltip>
        </div>

        <app-dialog v-model="isOpenModalSelectItem" size="lg">
            <template #header>
                <span class="text-lg font-bold text-primary">
                    {{ isEditingItem ? "Editar filtro" : "Nuevo filtro" }}
                </span>
            </template>

            <div>
                <p class="text-sm text-primary mb-5">
                    Selecciona el tipo de filtro, configura las opciones y
                    guarda.
                </p>

                <div class="mb-4">
                    <label
                        for="filterType"
                        class="block text-md font-semibold uppercase tracking-wider text-primary mb-1.5"
                    >
                        Tipo de filtro
                    </label>
                    <custom-simple-select
                        id="filterType"
                        v-model="itemTemp.key"
                        :disabled="isEditingItem"
                        class="w-full bg-theme-canvas rounded-xl"
                        :options="filterTypeOptions"
                    />
                </div>

                <div class="grid grid-cols-2 gap-4 mb-4">
                    <div>
                        <label
                            for="key_"
                            class="block text-xs font-semibold uppercase tracking-wider text-primary mb-1.5"
                        >
                            Llave de búsqueda
                        </label>
                        <custom-input
                            id="key_"
                            v-model="itemTemp.key"
                            :disabled="isEditingItem"
                            autocomplete="off"
                            class="mb-2"
                            type="text"
                            name="key"
                        />
                    </div>
                    <div>
                        <label
                            for="name_"
                            class="block text-xs font-semibold uppercase tracking-wider text-primary mb-1.5"
                        >
                            Nombre
                        </label>
                        <custom-input
                            id="name_"
                            v-model="itemTemp.name"
                            class="mb-2"
                            autocomplete="off"
                            type="text"
                            name="name"
                        />
                    </div>
                </div>

                <transition name="fade">
                    <div
                        v-if="itemTemp.type === 'range'"
                        class="grid grid-cols-3 gap-4 pt-4 mt-2 border-t border-theme-border"
                    >
                        <div>
                            <label
                                for="start_"
                                class="block text-xs font-semibold uppercase tracking-wider text-primary mb-1.5"
                                >Inicio</label
                            >
                            <custom-input
                                id="start_"
                                v-model="start"
                                autocomplete="off"
                                step="10000"
                                type="text"
                                name="start"
                                @input="formatStart"
                            />
                        </div>
                        <div>
                            <label
                                for="end_"
                                class="block text-xs font-semibold uppercase tracking-wider text-primary mb-1.5"
                                >Fin</label
                            >
                            <custom-input
                                id="end_"
                                v-model="end"
                                autocomplete="off"
                                step="10000"
                                type="text"
                                name="end"
                                @input="formatEnd"
                            />
                        </div>
                        <div>
                            <label
                                for="step_"
                                class="block text-xs font-semibold uppercase tracking-wider text-primary mb-1.5"
                                >Salto</label
                            >
                            <custom-input
                                id="step_"
                                v-model="step"
                                autocomplete="off"
                                step="10000"
                                type="text"
                                name="step"
                                @input="formatStep"
                            />
                        </div>
                    </div>
                </transition>

                <transition name="fade">
                    <div
                        v-if="
                            itemTemp.type === 'checkbox' ||
                            itemTemp.type === 'select'
                        "
                        class="pt-4 mt-2 border-t border-theme-border"
                    >
                        <template v-if="isTagsItemsFromCatalog">
                            <tags-selector
                                v-model="itemTempItemsAsValues"
                                :tags="tenantTagsCatalog"
                                :enabled="enabled"
                            />
                        </template>
                        <template v-else>
                            <div
                                class="flex gap-3 p-3 rounded-lg bg-theme-hover border border-theme-border mb-4"
                            >
                                <span
                                    class="text-theme-warning text-base flex-shrink-0"
                                >
                                    ❗
                                </span>
                                <p
                                    class="text-sm text-theme-base leading-relaxed m-0"
                                >
                                    El <strong>nombre</strong> es el texto
                                    visible para el cliente en la pagina. El
                                    <strong>valor</strong> debe estar en inglés
                                    con formato
                                    <code
                                        class="bg-theme-hover rounded px-1 font-mono"
                                    >
                                        snake_case </code
                                    >.
                                </p>
                            </div>
                            <feature-manage v-model="itemTemp.items" enabled />
                        </template>
                    </div>
                </transition>

                <transition name="fade">
                    <div
                        v-if="showDuplicate"
                        class="flex items-center gap-2 mt-4 px-3 py-2.5 rounded-lg bg-theme-hover border border-theme-border text-theme-danger text-sm font-medium"
                    >
                        <span>⚠️</span>
                        <span>
                            Ya existe un filtro con la llave
                            <strong>{{ itemTemp.key }}</strong>
                        </span>
                    </div>
                </transition>

                <div
                    class="flex justify-end mt-6 pt-4 border-t border-theme-border"
                >
                    <app-button
                        :disabled="isInvalidCurrentItem"
                        border
                        gradient
                        @click="pushOrUpdateItem"
                    >
                        <span class="text-sm font-semibold">
                            {{
                                isEditingItem ? "Actualizar" : "Guardar filtro"
                            }}
                        </span>
                    </app-button>
                </div>
            </div>
        </app-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { filtersTypes } from "@/common/fields/filters-types";
import { OperationsModes } from "@/common/fields/operations-modes";

import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";
import FeatureManage from "@/components/utils/FeatureManage.vue";
import TagsSelector from "@/components/utils/TagsSelector.vue";

export default {
    name: "FiltersManage",
    components: {
        AppDialog,
        CustomInput,
        CustomSimpleSelect,
        FeatureManage,
        TagsSelector
    },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Array,
            default: () => [],
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        isOpenModalSelectItem: false,
        $filtersTypes: filtersTypes,
        selectedFilters: [],
        itemTemp: {
            name: "",
            type: "",
            key: "",
            items: [],
            range: {
                start: 0,
                end: 20000,
                step: 10000
            }
        },
        start: "$0",
        end: "$20.000",
        step: "$10.000",
        edit: false,
        showDuplicate: false,
        isEditingItem: false,
        tenantTagsCatalog: [],
        tenantTagsCatalogLoaded: false,
        filterTypeOptions: filtersTypes.map((item) => ({
            label: item.value,
            value: item.key
        }))
    }),
    computed: {
        ...mapGetters("control", ["tableDark"]),
        isInvalidCurrentItem() {
            return (
                this.itemTemp.name === "" ||
                this.itemTemp.type === "" ||
                this.itemTemp.key === "" ||
                this.showDuplicate
            );
        },
        itemTempType() {
            return this.itemTemp.type;
        },
        itemTempKey() {
            return this.itemTemp.key;
        },
        hasTagsCatalogPermission() {
            return (
                this.$ability.hasPermission("tenant:GetTagsSettings") &&
                this.$operationMode !== OperationsModes.multiTenant
            );
        },
        isTagsItemsFromCatalog() {
            return (
                this.itemTemp.key === "tags" && this.hasTagsCatalogPermission
            );
        },
        itemTempItemsAsValues: {
            get() {
                return this.itemTemp.items.map((item) => item.value);
            },
            set(values) {
                this.itemTemp.items = values.map((value) => {
                    const tag = this.tenantTagsCatalog.find(
                        (item) => item.value === value
                    );
                    return { name: tag ? tag.name : value, value };
                });
            }
        }
    },
    watch: {
        itemTempKey(value) {
            if (this.isEditingItem) return;
            const filter = filtersTypes.find((item) => item.key === value);
            if (filter) {
                this.itemTemp.name = filter.name;
                this.itemTemp.type = filter.type;
                this.itemTemp.items = filter.items;
                this.itemTemp.range = filter.range;
            }
            this.showDuplicate = this.itemsCurrent.some(
                (item) => item.key === value
            );
        }
    },
    methods: {
        ...mapActions("tenants", ["getTenantTagsSettings"]),
        async ensureTenantTagsCatalogLoaded() {
            if (!this.hasTagsCatalogPermission || this.tenantTagsCatalogLoaded)
                return;
            try {
                const data = await this.getTenantTagsSettings();
                this.tenantTagsCatalog = Array.isArray(data.tags)
                    ? data.tags
                    : [];
                this.tenantTagsCatalogLoaded = true;
            } catch {
                this.tenantTagsCatalog = [];
            }
        },
        moveOrder(fromIndex, toIndex) {
            let arrAux = [...this.itemsCurrent];
            const aux = arrAux[fromIndex];
            arrAux.splice(fromIndex, 1);
            arrAux.splice(toIndex, 0, aux);
            this.$emit("change", arrAux);
        },
        editItem(fromIndex) {
            this.isEditingItem = true;
            let arrAux = [...this.itemsCurrent];
            this.itemTemp = arrAux[fromIndex];
            this.isOpenModalSelectItem = true;
            this.ensureTenantTagsCatalogLoaded();
            if ("step" in this.itemTemp) {
                this.end = this.$options.filters.currency(
                    Number(this.itemTemp.range.end)
                );
                this.step = this.$options.filters.currency(
                    Number(this.itemTemp.range.step)
                );
                this.start = this.$options.filters.currency(
                    Number(this.itemTemp.range.start)
                );
            }
        },
        deleteItem(fromIndex) {
            let itemsResult = [...this.itemsCurrent];
            itemsResult.splice(fromIndex, 1);
            this.$emit("change", itemsResult);
        },
        selectionFilter(id) {
            this.selectedFilters.push(id);
        },
        openNewFilter() {
            this.itemTemp = {
                name: "",
                type: "",
                key: "",
                items: [],
                range: {
                    start: 0,
                    end: 20000,
                    step: 10000
                }
            };
            this.isOpenModalSelectItem = true;
            this.ensureTenantTagsCatalogLoaded();
        },
        pushOrUpdateItem() {
            const itemsAux = [...this.itemsCurrent];
            if (this.isEditingItem) {
                const itemAux = itemsAux.findIndex(
                    (item) => item.key === this.itemTemp.key
                );
                itemsAux[itemAux] = this.itemTemp;
                this.isEditingItem = false;
            } else {
                itemsAux.push(this.itemTemp);
            }
            this.$emit("change", itemsAux);
            this.isOpenModalSelectItem = false;
        },
        formatStep() {
            this.itemTemp.range.step = parseInt(
                this.step.replace(/[^0-9]+/g, "")
            );
            this.step = this.$options.filters.currency(
                this.itemTemp.range.step
            );
        },
        formatEnd() {
            this.itemTemp.range.end = parseInt(
                this.end.replace(/[^0-9]+/g, "")
            );
            this.end = this.$options.filters.currency(this.itemTemp.range.end);
        },
        formatStart() {
            this.itemTemp.range.start = parseInt(
                this.start.replace(/[^0-9]+/g, "")
            );
            this.start = this.$options.filters.currency(
                this.itemTemp.range.start
            );
        }
    }
};
</script>
